
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'reference',
  description: 'Troubleshooting the Plaid Android SDK'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Troubleshooting the Plaid Link Android SDK' mdxType="Header" />
    <h4 {...{
      "id": "troubleshooting-oauth-errors"
    }}>{`Troubleshooting OAuth errors`}</h4>
    <p>{`A troubleshooting guide for common OAuth errors is below.`}</p>
    <h4 {...{
      "id": "no-redirect-out-of-app"
    }}>{`No redirect out of app`}</h4>
    <h5 {...{
      "id": "link-user-experience"
    }}>{`Link user experience`}</h5>
    <ul>
      <li parentName="ul">{`In Link, after clicking "Continue" on the OAuth screen, nothing happens.`}</li>
    </ul>
    <h5 {...{
      "id": "common-causes"
    }}>{`Common causes`}</h5>
    <ul>
      <li parentName="ul">{`The user may be using an unsupported browser that is not compatible with Plaid's OAuth redirects, such as DuckDuckGo. For more details on which browsers are supported, see `}<a parentName="li" {...{
          "href": "/docs/link/web/#supported-browsers"
        }}>{`Supported browsers`}</a>{`.`}</li>
    </ul>
    <h5 {...{
      "id": "troubleshooting-steps"
    }}>{`Troubleshooting steps`}</h5>
    <Checkbox checklistId='OAUTH-1a' mdxType="Checkbox">
      <p>{`Try again with Google Chrome.`}</p>
    </Checkbox>
    <h4 {...{
      "id": "no-redirect-back-to-app"
    }}>{`No redirect back to app`}</h4>
    <h5 {...{
      "id": "link-user-experience-1"
    }}>{`Link user experience`}</h5>
    <ul>
      <li parentName="ul">{`After completing OAuth in the browser or financial institution's app, the user is not redirected back to your app.`}</li>
    </ul>
    <h5 {...{
      "id": "common-causes-1"
    }}>{`Common causes`}</h5>
    <ul>
      <li parentName="ul">{`The webpage is unable to locate an app on the device with a package id matching the one used to create the Link token.`}</li>
    </ul>
    <h5 {...{
      "id": "troubleshooting-steps-1"
    }}>{`Troubleshooting steps`}</h5>
    <Checkbox checklistId='OAUTH-1b' mdxType="Checkbox">
      <p>{`Check that the package id you passed in matched the package id of the app you are using.`}</p>
    </Checkbox>
    <h4 {...{
      "id": "the-play-store-opened-upon-redirect"
    }}>{`The Play Store opened upon redirect`}</h4>
    <h5 {...{
      "id": "link-user-experience-2"
    }}>{`Link user experience`}</h5>
    <ul>
      <li parentName="ul">{`After completing OAuth in the browser or financial institution's app, the Google Play store opened.`}</li>
    </ul>
    <h5 {...{
      "id": "common-causes-2"
    }}>{`Common causes`}</h5>
    <ul>
      <li parentName="ul">{`The webpage is unable to locate an app on the device with the package id matching the one used to create the Link token.`}</li>
    </ul>
    <h5 {...{
      "id": "troubleshooting-steps-2"
    }}>{`Troubleshooting steps`}</h5>
    <Checkbox checklistId='OAUTH-1c' mdxType="Checkbox">
      <p>{`Check that the package name used to create the Link token matches the package name of the app it was used in.`}</p>
    </Checkbox>
    <h4 {...{
      "id": "link-opens-then-immediately-closes-upon-redirect"
    }}>{`Link opens, then immediately closes upon redirect`}</h4>
    <h5 {...{
      "id": "link-user-experience-3"
    }}>{`Link user experience`}</h5>
    <p>{`After completing OAuth in the browser or financial institution's app, Link opens and then closes again.`}</p>
    <h5 {...{
      "id": "common-causes-3"
    }}>{`Common causes`}</h5>
    <ul>
      <li parentName="ul">{`The webpage redirected back to the wrong application on the device causing Link to open and immediately close again as it gets data from a different session.`}</li>
      <li parentName="ul">{`You may have both a test and a release version of your app installed on your device and used the wrong package name when creating the Link token.`}</li>
    </ul>
    <h5 {...{
      "id": "troubleshooting-steps-3"
    }}>{`Troubleshooting steps`}</h5>
    <Checkbox checklistId='OAUTH-2' mdxType="Checkbox">
      <p>{`Check that the package name used to create the Link token matches the package name of the app it was used in.`}</p>
    </Checkbox>
    <h4 {...{
      "id": "other-common-errors"
    }}>{`Other common errors`}</h4>
    <p>{`To troubleshoot an error with an error code, use the `}<a parentName="p" {...{
        "href": "/docs/errors"
      }}>{`error troubleshooting guide`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "troubleshooting-oauth-errors",
        level: 4,
        title: "Troubleshooting OAuth errors",
      },
{
        id: "no-redirect-out-of-app",
        level: 4,
        title: "No redirect out of app",
      },
{
        id: "no-redirect-back-to-app",
        level: 4,
        title: "No redirect back to app",
      },
{
        id: "the-play-store-opened-upon-redirect",
        level: 4,
        title: "The Play Store opened upon redirect",
      },
{
        id: "link-opens-then-immediately-closes-upon-redirect",
        level: 4,
        title: "Link opens, then immediately closes upon redirect",
      },
{
        id: "other-common-errors",
        level: 4,
        title: "Other common errors",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
